import React, { useContext, useReducer } from 'react';
import { CurrentMode } from '../types/type';
import moment, { Moment } from 'moment';

type QuerysProviderProps = {
  initState?: any;
};
interface IOriginState {
  currentTime: number;
  currentMode: CurrentMode;
  calendarMonth: Moment;
  isFirstBlink: boolean;
}

interface IContext {
  originState: IOriginState;
  scheduleDispatch: React.Dispatch<AnyAction>;
}

/*
 actionTppe
*/
interface AnyAction {
  type: 'SET_STATE';
  payload: { [key: string]: any };
}

/*
 reducer
*/
function modelReducer(state: IOriginState, action: AnyAction) {
  switch (action.type) {
    case 'SET_STATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

const originState = {
  currentTime: moment().startOf('day').valueOf(),
  currentMode: CurrentMode.schedule,
  calendarMonth: moment().startOf('day'),
  isFirstBlink: true
};

const defaultContent = {
  originState,
  scheduleDispatch: () => {}
};

const ScheduleContext = React.createContext<IContext>(defaultContent);

export function useScheduleContext() {
  return useContext(ScheduleContext);
}

const ScheduleProvider: React.FC<QuerysProviderProps> = (props) => {
  const { children } = props;
  const [state, scheduleDispatch] = useReducer(modelReducer, { ...originState });

  return <ScheduleContext.Provider value={{ originState: state, scheduleDispatch }}>{children}</ScheduleContext.Provider>;
};
export default ScheduleProvider;
